export var pcCssPrefix = 'cn-ding-talk-camera-upload';
export var mCssPrefix = 'cn-ui-m-ding-talk-camera-upload';
